import { Component, computed, input } from '@angular/core';
import { INewDwellingProjectData } from 'src/app/infopage/new-new-dwelling/newdwelling.model';
import { EVEstateType, EVOwnership } from 'src/models/units/unit-attributes.model';
import { EvDatePipe } from '@shared/pipes/evDate.pipe';

@Component({
    selector: 'key-info-project',
    standalone: true,
    templateUrl: './key-info-project.component.html',
    styleUrl: './key-info-project.component.scss',
})
export class KeyInfoProjectComponent {

    projectData = input.required<INewDwellingProjectData>();
    stageMode = input<boolean>(false);


    developers = computed(() => this.projectData()?.projectInfo?.developers ?? []);

    estateAgents = computed(() => {
        if (this.stageMode()) {
            return this.projectData()?.projectStage?.estateAgents ?? [];
        }
        return this.projectData()?.projectInfo?.estateAgents ?? [];
    });

    saleStart = computed(() => this.projectData()?.projectStage?.saleStart);

    ownershipText = computed(() => this.makeOwnershipText(this.projectData()?.projectStage?.ownershipId));

    unitInfo = computed(() => {
        const stage = this.projectData()?.projectStage;
        const numUnits = stage?.numUnits ?? 0;
        const estateType = this.getPluralEstateType(stage?.estateType, stage?.estateTypeString, numUnits);
        return `${numUnits} ${estateType}`.trim();
    });

    private makeOwnershipText(ownershipId: number): string {
        switch (ownershipId) {
            case EVOwnership.Ukjent:
                return 'Ukjent';
            case EVOwnership.Selveier:
                return 'Selveier';
            case EVOwnership.Borettslag:
                return 'Borettslag';
            case EVOwnership.Aksjeleilighet:
                return 'Aksjeleilighet';
            case EVOwnership.Obl_leilighet:
                return 'Obligasjonsleilighet';
            default:
                return '';
        }
    }

    private getPluralEstateType(estateType: EVEstateType | null, estateTypeString: string, numberOfUnits: number): string {
        if (estateType === EVEstateType.Ukjent || estateType == null) {
            return '';
        }

        if (estateType !== EVEstateType.Rekkehus && numberOfUnits > 1) {
            return `${estateTypeString}er`;
        }

        return estateTypeString;
    }
}
